import { useLoadingContext } from 'contexts/hooks/useLoadingContext';
import { LoadingContext } from 'contexts/LoadingContext';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
export const withLoadingContext = <TProps extends {}, TRef = HTMLElement>(
  WrappedComponent: React.ComponentType<TProps>
) =>
  React.forwardRef<TRef, TProps>((props, ref) => {
    const contextValue = useLoadingContext();
    return (
      <LoadingContext.Provider value={contextValue}>
        <WrappedComponent {...(props as TProps)} ref={ref} />
      </LoadingContext.Provider>
    );
  });
